import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, FloatingInput } from '@piplapps/pipl-ui';
import styles from './RenameTeamModal.module.less';
import LoadingButton from '../../../Components/LoadingButton';
import AnalyticsHandler from '../../../Utils/AnalyticsHandler/AnalyticsHandler';
import AnalyticsEventNames from '../../../Utils/AnalyticsHandler/AnalyticsEventNames';
import { UsersActions } from '../../../Redux/modules/users/actions';

const RenameTeamModal = (props) => {
  const { userData, teams } = props;

  const [name, resetName] = useState(userData.name);
  const [error, setError] = useState(null);

  const validateName = () => {
    const teamNames = teams.map((team) => team.name.toLowerCase());
    const hasError = teamNames.includes(name.toLowerCase()) && name !== userData.name;
    if (!name || name.trim() === '' || name.trim().length < 2) {
      setError('Name must have at least 2 characters');
    } else if (hasError) {
      setError('This team name already exists');
    } else {
      setError(null);
    }
  };

  const handleSubmit = () => {
    if (name === userData.name) {
      props.clickedCloseModalButton();
    } else {
      props.onRenameTeam({ team_id: userData.id, name: name.trim() });
    }
  };

  return (
    <div className={styles.modalContainer}>
      <div className={styles.header}>{props.title}</div>
      <span
        tabIndex={0}
        role="button"
        className={styles.close}
        onClick={() => {
          props.clickedCloseModalButton();
        }}
      >
        &times;
      </span>

      <div className={styles.text}>
        <FloatingInput
          id="id_team_name"
          name="team_name"
          testId="team-name-input"
          placeholder="Team name"
          value={name}
          onChange={(e) => resetName(e.target.value)}
          successColor="#8792a9"
          forcedError={error}
          onBlur={validateName}
          autoComplete="off"
          autoFocus
        />
      </div>

      <div className={styles.buttonContainer}>
        <div className={styles.buttonWrapper}>
          <AnalyticsHandler
            eventName={AnalyticsEventNames.RENAME_TEAM}
            eventData={{ teamName: name, teamPreviousName: userData.name, teamId: userData.id }}
          >
            <LoadingButton
              id="submit-button"
              buttonClass="primary-blue"
              type="submit"
              onClick={() => handleSubmit()}
              text={gettext('Rename team')}
              disabled={!!error}
            />
          </AnalyticsHandler>
        </div>
        <div className={styles.buttonWrapper}>
          <Button
            buttonClass="secondary-blue"
            onClick={() => props.clickedCloseModalButton()}
            text={gettext('Cancel')}
            id="cancel-button"
          />
        </div>
      </div>
    </div>
  );
};

RenameTeamModal.propTypes = {
  userData: PropTypes.object,
  title: PropTypes.string,
  onRenameTeam: PropTypes.func,
  clickedCloseModalButton: PropTypes.func,
  teams: PropTypes.array,
};

const mapDispatchToProps = {
  clickedCloseModalButton: UsersActions.clickedCloseModalButton,
  onRenameTeam: UsersActions.renameTeam,
};

export default connect(null, mapDispatchToProps)(RenameTeamModal);
